/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckRun
 */
export interface CheckRun {
    /**
     * 
     * @type {string}
     * @memberof CheckRun
     */
    check: string;
    /**
     * 
     * @type {string}
     * @memberof CheckRun
     */
    outcome: CheckRunOutcomeEnum;
    /**
     * Stable machine code identifying the result of the check. Each `check` name has its own enum (e.g. `GeoCheckCode` for `geo`). Consumers should narrow by `check` before interpreting.
     * @type {string}
     * @memberof CheckRun
     */
    code: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CheckRun
     */
    detail?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof CheckRun
     */
    ran_at: Date;
}


/**
 * @export
 */
export const CheckRunOutcomeEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A'
} as const;
export type CheckRunOutcomeEnum = typeof CheckRunOutcomeEnum[keyof typeof CheckRunOutcomeEnum];


/**
 * Check if a given object implements the CheckRun interface.
 */
export function instanceOfCheckRun(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "check" in value;
    isInstance = isInstance && "outcome" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "ran_at" in value;

    return isInstance;
}

export function CheckRunFromJSON(json: any): CheckRun {
    return CheckRunFromJSONTyped(json, false);
}

export function CheckRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRun {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'check': json['check'],
        'outcome': json['outcome'],
        'code': json['code'],
        'detail': !exists(json, 'detail') ? undefined : json['detail'],
        'ran_at': (new Date(json['ran_at'])),
    };
}

export function CheckRunToJSON(value?: CheckRun | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'check': value.check,
        'outcome': value.outcome,
        'code': value.code,
        'detail': value.detail,
        'ran_at': (value.ran_at.toISOString()),
    };
}

